import ChartRingIcon from '../../../assets/icons/aiChat/ChartRingIcon';
import SparkleIcon from '../../../assets/icons/aiChat/SparkleIcon';

const QUICK_PROMPTS = [
  {
    text: 'Help me start with Intellect Ask AI',
    icon: <SparkleIcon className="h-5 w-5 text-violet-500" />,
  },
  {
    text: 'What are the key risk for my employee wellbeing?',
    icon: <ChartRingIcon className="h-5 w-5 text-orange-500" />,
  },
  {
    text: 'Visualise my utilisation of the self-care content',
    icon: <ChartRingIcon className="h-5 w-5 text-blue-500" />,
  },
] as const;

type AIChatEmptyStateProps = {
  onSelectPrompt: (text: string) => void;
  disabled?: boolean;
};

export default function AIChatEmptyState({
  onSelectPrompt,
  disabled,
}: AIChatEmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 py-8">
      <h4 className="text-black-900 mb-8 text-center text-base font-medium">
        How can I help you today?
      </h4>
      <div className="flex w-full flex-col gap-3">
        {QUICK_PROMPTS.map((item) => (
          <button
            key={item.text}
            type="button"
            disabled={disabled}
            onClick={() => onSelectPrompt(item.text)}
            className="text-black-900 flex w-full cursor-pointer items-center gap-3 rounded-2xl bg-violet-50 px-4 py-4 text-left text-sm font-medium transition hover:bg-violet-100 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center">
              {item.icon}
            </span>
            {item.text}
          </button>
        ))}
      </div>
    </div>
  );
}
